import { useState, useEffect } from 'react';
import './Content.css';
// import * as slidesData from '../constants/slidesScope';
import * as slideDataWCS from '../constants/slidesScopeWithoutCommonSense';
import Slide from './Slide';
import { ChronoContext } from '../contexts/ChronoContext';
import { SlidesContext } from '../contexts/SlidesContext';
import { StepContext } from '../contexts/StepContext';
import { ButtonNext } from '../contexts/ButtonNext';
import Preferences from '../generics/Preferences';
import logger from '../utils/frontendLogger';

// const slides = slidesData.slides;

/*const testAnswers = [
    {
        "SUPPOSITIONQUESTION5": false,
        "SUPPOSITIONQUESTION6": false,
        "SUPPOSITIONQUESTION7": true,
        "SUPPOSITIONQUESTION8": false,
    },
    {
        "SUPPOSITIONQUESTION9": false,
        "SUPPOSITIONQUESTION10": false,
        "SUPPOSITIONQUESTION11": false,
        "SUPPOSITIONQUESTION12": true,
    },
    {
        "SUPPOSITIONQUESTION13": false,
        "SUPPOSITIONQUESTION14": false,
        "SUPPOSITIONQUESTION15": false,
        "SUPPOSITIONQUESTION16": false
    },
    {
        "TP1": 0
    },
    {
        "TP2": 0
    },
    {
        "TP3": 0
    },
    {
        "TP4": 0
    },
    {
        "TP5": 0
    },
    {
        "TP6": 0
    },
    {
        "TP7": 0
    },
    {
        "TP8": 0
    },
    {
        "PREF1": ""
    },
    {
        "PREF2": ""
    },
    {
        "PREF3": ""
    },
    {
        "PREF4": ""
    },
    {
        "PREF5": ""
    },
    {
        "PREF6": ""
    },
    {
        "PREF7": ""
    },
    {
        "PREF8": ""
    },
    {
        "PREF9": ""
    },
    {
        "PREF10": ""
    },
    {
        "PREF11": ""
    },
    {
        "PREF12": ""
    },
    {
        "PREF13": ""
    },
    {
        "PREF14": ""
    },
    {
        "PREF15": ""
    },
    {
        "SS1": 0
    },
    {
        "SS2": 0
    },
    {
        "SS3": 0
    },
    {
        "SS4": 0
    },
    {
        "SS5": 0
    },
    {
        "SS6": 0
    },
    {
        "SS7": 0
    },
    {
        "SS8": 0
    },
    {
        "SS9": 0
    },
    {
        "PTC1": ""
    },
    {
        "PTC2": ""
    },
    {
        "PTC3": ""
    },
    {
        "PTC4": ""
    },
    {
        "PTC5": ""
    },
    {
        "PTC6": ""
    },
    {
        "PTC7": ""
    },
    {
        "PTC8": ""
    },
    {
        "PTC9": ""
    },
    {
        "PTC10": ""
    },
    {
        "PTC11": ""
    },
    {
        "PTC12": ""
    },
    {
        "PTC13": ""
    },
    {
        "PTC14": ""
    },
    {
        "PTC15": ""
    },
    {
        "PTC16": ""
    },
    {
        "PTC17": ""
    },
    {
        "PTC18": ""
    },
    {
        "PTC19": ""
    },
    {
        "PTC20": ""
    },
    {
        "PTC21": ""
    },
    {
        "PTC22": ""
    },
    {
        "PTC23": ""
    },
    {
        "PTC24": ""
    },
    {
        "PTC25": ""
    },
    {
        "PTC26": ""
    },
    {
        "PTC27": ""
    },
    {
        "PTC28": ""
    },
    {
        "PTC29": ""
    },
    {
        "PTC30": ""
    },
    {
        "PTC31": ""
    },
    {
        "PTC32": ""
    },
    {
        "PTC33": ""
    },
    {
        "PTC34": ""
    },
    {
        "PTC35": ""
    },
    {
        "PTC36": ""
    },
    {
        "PTC37": ""
    },
    {
        "PTC38": ""
    },
    {
        "PTC39": ""
    },
    {
        "REACTIONSEMO1POSSIBILITE1": "0",
        "REACTIONSEMO1POSSIBILITE2": "0",
        "REACTIONSEMO1POSSIBILITE3": "0",
        "REACTIONSEMO1POSSIBILITE4": "0",
        "REACTIONSEMO1POSSIBILITE5": "0"
    },
    {
        "REACTIONSEMO2POSSIBILITE1": "0",
        "REACTIONSEMO2POSSIBILITE2": "0",
        "REACTIONSEMO2POSSIBILITE3": "0",
        "REACTIONSEMO2POSSIBILITE4": "0",
        "REACTIONSEMO2POSSIBILITE5": "0"
    },
    {
        "REACTIONSEMO3POSSIBILITE1": "0",
        "REACTIONSEMO3POSSIBILITE2": "0",
        "REACTIONSEMO3POSSIBILITE3": "0",
        "REACTIONSEMO3POSSIBILITE4": "0",
        "REACTIONSEMO3POSSIBILITE5": "0"
    },
    {
        "REACTIONSEMO4POSSIBILITE1": "0",
        "REACTIONSEMO4POSSIBILITE2": "0",
        "REACTIONSEMO4POSSIBILITE3": "0",
        "REACTIONSEMO4POSSIBILITE4": "0",
        "REACTIONSEMO4POSSIBILITE5": "0"
    },
    {
        "REACTIONSEMO5POSSIBILITE1": "0",
        "REACTIONSEMO5POSSIBILITE2": "0",
        "REACTIONSEMO5POSSIBILITE3": "0",
        "REACTIONSEMO5POSSIBILITE4": "0",
        "REACTIONSEMO5POSSIBILITE5": "0"
    },
    {
        "TESTLOGIQUE2DEDUCTIONS1": false,
        "TESTLOGIQUE2DEDUCTIONS2": false,
        "TESTLOGIQUE2DEDUCTIONS3": false,
        "TESTLOGIQUE2DEDUCTIONS4": false,
        "TESTLOGIQUE2DEDUCTIONS5": false,
        "TESTLOGIQUE2DEDUCTIONS6": false
    },
    {
        "TESTLOGIQUE3DEDUCTIONS1": false,
        "TESTLOGIQUE3DEDUCTIONS2": false,
        "TESTLOGIQUE3DEDUCTIONS3": false,
        "TESTLOGIQUE3DEDUCTIONS4": false,
        "TESTLOGIQUE3DEDUCTIONS5": false,
        "TESTLOGIQUE3DEDUCTIONS6": false
    },
    {
        "TESTLOGIQUE4DEDUCTIONS1": false,
        "TESTLOGIQUE4DEDUCTIONS2": false,
        "TESTLOGIQUE4DEDUCTIONS3": false,
        "TESTLOGIQUE4DEDUCTIONS4": false,
        "TESTLOGIQUE4DEDUCTIONS5": false,
        "TESTLOGIQUE4DEDUCTIONS6": false
    },
    {
        "VH1": ""
    },
    {
        "VH2": ""
    },
    {
        "VH3": ""
    },
    {
        "VH4": ""
    },
    {
        "VH5": ""
    },
    {
        "VH6": ""
    },
    {
        "VH7": ""
    },
    {
        "VH8": ""
    },
    {
        "VH9": ""
    },
    {
        "VH10": ""
    },
    {
        "VH11": ""
    },
    {
        "VH12": ""
    },
    {
        "VH13": ""
    },
    {
        "VH14": ""
    },
    {
        "VH15": ""
    },
    {
        "SEXE": ""
    },
    {
        "AGE": ""
    },
    {
        "ECOLE": ""
    },
    {
        "CONTINENT": "North America",
         "CONTINENT_timestamp": {
            "hours": 0,
            "minutes": 5,
            "seconds": 33,
            "totalSeconds": 33
        }
    },
    {
        "POSTE": ""
    }
];
*/
const slidesWCS = slideDataWCS.slides;
// Dynamically build initialStateWCS to match inputNumber and structure of each slide
const initialStateWCS = [];
for (let i = 0; i < slidesWCS.length; i++) {
  const slide = slidesWCS[i];
  if (typeof slide.inputNumber !== 'number') continue;
  // For FAITS VS OPINIONS: pageCheckBox with leftLabel/rightLabel
  if (Array.isArray(slide.inputsCB) && slide.leftLabel && slide.rightLabel) {
    const obj = {};
    for (const cb of slide.inputsCB) {
      if (cb && cb.key) obj[cb.key] = typeof cb.value !== 'undefined' ? cb.value : '';
    }
    initialStateWCS[slide.inputNumber] = obj;
    continue;
  }
  // For pageCheckBox and similar: use inputsCB
  if (Array.isArray(slide.inputsCB)) {
    const obj = {};
    for (const cb of slide.inputsCB) {
      if (cb && cb.key) obj[cb.key] = typeof cb.value !== 'undefined' ? cb.value : false;
    }
    initialStateWCS[slide.inputNumber] = obj;
    continue;
  }
  // For pageMultiSlider and similar: use inputsMS
  if (Array.isArray(slide.inputsMS)) {
    const obj = {};
    for (const ms of slide.inputsMS) {
      if (ms && ms.key) obj[ms.key] = typeof ms.value !== 'undefined' ? ms.value : '0';
    }
    initialStateWCS[slide.inputNumber] = obj;
    continue;
  }
  // For single key/value slides
  if (typeof slide.key === 'string') {
    initialStateWCS[slide.inputNumber] = {
      [slide.key]: typeof slide.value !== 'undefined' ? slide.value : ''
    };
    continue;
  }
}
// Fill all undefined indices up to the max used with empty objects
const maxIdx = initialStateWCS.length;
for (let i = 0; i < maxIdx; i++) {
  if (typeof initialStateWCS[i] === 'undefined') initialStateWCS[i] = {};
}

/* const initialState = [
  {
    TF1 : slides[2].value,
  },
  {
    TF2 : slides[3].value,
  },
  {
    TF3 : slides[4].value,
  },
  {
    TF4 : slides[5].value,
  },
  {
    TF5 : slides[6].value,
  },
  {
    TF6 : slides[7].value,
  },
  {
    TF7 : slides[8].value,
  },
  {
    TF8 : slides[9].value,
  },
  {
    TF9 : slides[10].value,
  },
  {
    TF10 : slides[11].value,
  },
  {
    TF11 : slides[12].value,
  },
  {
    TF12 : slides[13].value,
  },
  {
    TF13 : slides[14].value,
  },
  {
    TF14 : slides[15].value,
  },
  {
    TF15 : slides[16].value,
  },
  {
    TF16 : slides[17].value,
  },
  {
    TF17 : slides[18].value,
  },
  {
    TF18 : slides[19].value,
  },
  {
    TF19 : slides[20].value,
  },
  {
    TF20 : slides[21].value,
  },
  {
    TF21 : slides[22].value,
  },
  {
    TF22 : slides[23].value,
  },
  {
    TF23 : slides[24].value,
  },
  {
    TF24 : slides[25].value,
  },
  {
    TF25 : slides[26].value,
  },
  {
    TF26 : slides[27].value,
  },
  {
    TF27 : slides[28].value,
  },
  {
    TF28 : slides[29].value,
  },  
  {
    TF29 : slides[30].value,
  },
  {
    TF30 : slides[31].value,
  },
  {
    TF31 : slides[32].value,
  },
  {
    TF32 : slides[33].value,
  },
  {
    TF33 : slides[34].value,
  },
  {
    TF34 : slides[35].value,
  },
  {
    SUPPOSITIONQUESTION5 : slides[37].inputsCB[0].value,
    SUPPOSITIONQUESTION6 : slides[37].inputsCB[1].value,
    SUPPOSITIONQUESTION7 : slides[37].inputsCB[2].value,
    SUPPOSITIONQUESTION8 : slides[37].inputsCB[3].value,
  },

  {
    SUPPOSITIONQUESTION9 : slides[38].inputsCB[0].value,
    SUPPOSITIONQUESTION10 : slides[38].inputsCB[1].value,
    SUPPOSITIONQUESTION11 : slides[38].inputsCB[2].value,
    SUPPOSITIONQUESTION12 : slides[38].inputsCB[3].value,
  },

  {
    SUPPOSITIONQUESTION13 : slides[39].inputsCB[0].value,
    SUPPOSITIONQUESTION14 : slides[39].inputsCB[1].value,
    SUPPOSITIONQUESTION15 : slides[39].inputsCB[2].value,
    SUPPOSITIONQUESTION16 : slides[39].inputsCB[3].value,
  },
////////////////////////
  {
    TP1 : slides[41].value,
  },
  {
    TP2 : slides[42].value,
  },
  {
    TP3 : slides[43].value,
  },
  {
    TP4 : slides[44].value,
  },
  {
    TP5 : slides[45].value,
  },
  {
    TP6 : slides[46].value,
  },
  {
    TP7 : slides[47].value,
  },
  {
    TP8 : slides[48].value,
  },
  ////////////////////////
  {
    PREF1 : slides[50].value,
  },
  {
    PREF2 : slides[51].value,
  },
  {
    PREF3 : slides[52].value,
  },
  {
    PREF4 : slides[53].value,
  },
  {
    PREF5 : slides[54].value,
  },
  {
    PREF6 : slides[55].value,
  },
  {
    PREF7 : slides[56].value,
  },
  {
    PREF8 : slides[57].value,
  },
  {
    PREF9 : slides[58].value,
  },
  {
    PREF10 : slides[59].value,
  },
  {
    PREF11 : slides[60].value,
  },
  {
    PREF12 : slides[61].value,
  },
  {
    PREF13 : slides[62].value,
  },
  {
    PREF14 : slides[63].value,
  },
  {
    PREF15 : slides[64].value,
  }, 
  ////////////////////////
  {
    SS1 : slides[66].value,
  },
  {
    SS2 : slides[67].value,
  },
  {
    SS3 : slides[68].value,
  },
  {
    SS4 : slides[69].value,
  },
  {
    SS5 : slides[70].value,
  },
  {
    SS6 : slides[71].value,
  },
  {
    SS7 : slides[72].value,
  },
  {
    SS8 : slides[73].value,
  },
  {
    SS9 : slides[74].value,
  },
  ////////////////////////
  {
    PTC1 : slides[76].value,
  }, 
  {
    PTC2 : slides[77].value,
  }, 
  {
    PTC3 : slides[78].value,
  }, 
  {
    PTC4 : slides[79].value,
  }, 
  {
    PTC5 : slides[80].value,
  }, 
  {
    PTC6 : slides[81].value,
  }, 
  {
    PTC7 : slides[82].value,
  }, 
  {
    PTC8 : slides[83].value,
  }, 
  {
    PTC9 : slides[84].value,
  }, 
  {
    PTC10 : slides[85].value,
  }, 
  {
    PTC11 : slides[86].value,
  },  
  {
    PTC12 : slides[87].value,
  }, 
  {
    PTC13 : slides[88].value,
  }, 
  {
    PTC14 : slides[89].value,
  }, 
  {
    PTC15 : slides[90].value,
  }, 
  {
    PTC16 : slides[91].value,
  }, 
  {
    PTC17 : slides[92].value,
  }, 
  {
    PTC18 : slides[93].value,
  }, 
  {
    PTC19 : slides[94].value,
  }, 
  {
    PTC20 : slides[95].value,
  }, 
  {
    PTC21 : slides[96].value,
  }, 
  {
    PTC22 : slides[97].value,
  }, 
  {
    PTC23 : slides[98].value,
  }, 
  {
    PTC24 : slides[99].value,
  }, 
  {
    PTC25 : slides[100].value,
  }, 
  {
    PTC26 : slides[101].value,
  }, 
  {
    PTC27 : slides[102].value,
  }, 
  {
    PTC28 : slides[103].value,
  },
  {
    PTC29 : slides[104].value,
  },  
  {
    PTC30 : slides[105].value,
  }, 
  {
    PTC31 : slides[106].value,
  }, 
  {
    PTC32 : slides[107].value,
  }, 
  {
    PTC33 : slides[108].value,
  }, 
  {
    PTC34 : slides[109].value,
  }, 
  {
    PTC35 : slides[110].value,
  }, 
  {
    PTC36 : slides[111].value,
  }, 
  {
    PTC37 : slides[112].value,
  },
  {
    PTC38 : slides[113].value,
  },
  {
    PTC39 : slides[114].value,
  },
  {
    REACTIONSEMO1POSSIBILITE1 : slides[116].inputsMS[0].value,
    REACTIONSEMO1POSSIBILITE2 : slides[116].inputsMS[1].value,
    REACTIONSEMO1POSSIBILITE3 : slides[116].inputsMS[2].value,
    REACTIONSEMO1POSSIBILITE4 : slides[116].inputsMS[3].value,
    REACTIONSEMO1POSSIBILITE5 : slides[116].inputsMS[4].value,
  },  
  {
    REACTIONSEMO2POSSIBILITE1 : slides[117].inputsMS[0].value,
    REACTIONSEMO2POSSIBILITE2 : slides[117].inputsMS[1].value,
    REACTIONSEMO2POSSIBILITE3 : slides[117].inputsMS[2].value,
    REACTIONSEMO2POSSIBILITE4 : slides[117].inputsMS[3].value,
    REACTIONSEMO2POSSIBILITE5 : slides[117].inputsMS[4].value,
  },

  {
    REACTIONSEMO3POSSIBILITE1 : slides[118].inputsMS[0].value,
    REACTIONSEMO3POSSIBILITE2 : slides[118].inputsMS[1].value,
    REACTIONSEMO3POSSIBILITE3 : slides[118].inputsMS[2].value,
    REACTIONSEMO3POSSIBILITE4 : slides[118].inputsMS[3].value,
    REACTIONSEMO3POSSIBILITE5 : slides[118].inputsMS[4].value,
  },

  {
    REACTIONSEMO4POSSIBILITE1 : slides[119].inputsMS[0].value,
    REACTIONSEMO4POSSIBILITE2 : slides[119].inputsMS[1].value,
    REACTIONSEMO4POSSIBILITE3 : slides[119].inputsMS[2].value,
    REACTIONSEMO4POSSIBILITE4 : slides[119].inputsMS[3].value,
    REACTIONSEMO4POSSIBILITE5 : slides[119].inputsMS[4].value,
  },

  {
    REACTIONSEMO5POSSIBILITE1 : slides[120].inputsMS[0].value,
    REACTIONSEMO5POSSIBILITE2 : slides[120].inputsMS[1].value,
    REACTIONSEMO5POSSIBILITE3 : slides[120].inputsMS[2].value,
    REACTIONSEMO5POSSIBILITE4 : slides[120].inputsMS[3].value,
    REACTIONSEMO5POSSIBILITE5 : slides[120].inputsMS[4].value,
  },  

  {
    TESTLOGIQUE2DEDUCTIONS1 : slides[122].inputsCB[0].value,
    TESTLOGIQUE2DEDUCTIONS2 : slides[122].inputsCB[1].value,
    TESTLOGIQUE2DEDUCTIONS3 : slides[122].inputsCB[2].value,
    TESTLOGIQUE2DEDUCTIONS4 : slides[122].inputsCB[3].value,
    TESTLOGIQUE2DEDUCTIONS5 : slides[122].inputsCB[4].value,
    TESTLOGIQUE2DEDUCTIONS6 : slides[122].inputsCB[5].value,
  },

  {
    TESTLOGIQUE3DEDUCTIONS1 : slides[123].inputsCB[0].value,
    TESTLOGIQUE3DEDUCTIONS2 : slides[123].inputsCB[1].value,
    TESTLOGIQUE3DEDUCTIONS3 : slides[123].inputsCB[2].value,
    TESTLOGIQUE3DEDUCTIONS4 : slides[123].inputsCB[3].value,
    TESTLOGIQUE3DEDUCTIONS5 : slides[123].inputsCB[4].value,
    TESTLOGIQUE3DEDUCTIONS6 : slides[123].inputsCB[5].value,
  },

  {
    TESTLOGIQUE4DEDUCTIONS1 : slides[124].inputsCB[0].value,
    TESTLOGIQUE4DEDUCTIONS2 : slides[124].inputsCB[1].value,
    TESTLOGIQUE4DEDUCTIONS3 : slides[124].inputsCB[2].value,
    TESTLOGIQUE4DEDUCTIONS4 : slides[124].inputsCB[3].value,
    TESTLOGIQUE4DEDUCTIONS5 : slides[124].inputsCB[4].value,
    TESTLOGIQUE4DEDUCTIONS6 : slides[124].inputsCB[5].value,
  },
  {
    VH1 : slides[126].value,
  }, 
  {
    VH2 : slides[126].value,
  }, 
  {
    VH3 : slides[126].value,
  }, 
  {
    VH4 : slides[126].value,
  }, 
  {
    VH5 : slides[126].value,
  }, 
  {
    VH6 : slides[126].value,
  }, 
  {
    VH7 : slides[126].value,
  }, 
  {
    VH8 : slides[126].value,
  }, 
  {
    VH9 : slides[126].value,
  }, 
  {
    VH10 : slides[126].value,
  }, 
  {
    VH11 : slides[126].value,
  }, 
  {
    VH12 : slides[126].value,
  }, 
  {
    VH13 : slides[126].value,
  }, 
  {
    VH14 : slides[126].value,
  }, 
  {
    VH15 : slides[126].value,
  },
  {
    SEXE : slides[127].value,
  },
  {
    AGE : slides[128].value,
  },
  {
    ECOLE : slides[129].value,
  },
  {
    CONTINENT : slides[130].value,
  },
  {
    POSTE : slides[131].value,
  },
]; */

export default function Content({token}) {
    const [chrono, setChrono] = useState({ hours: 0, minutes: 0, seconds: 0 });
    const [step, setStep] = useState(0);
    //const [step, setStep] = useState(testAnswers.length);
    const [buttonNext, setButtonNext] = useState(true);
    const [slidesAnswers, setSlidesAnswers] = useState(initialStateWCS);

    useEffect(() => {
        if (!token) {
            console.log("Token not set");
        }
        else {
            if (sessionStorage.getItem("answers")) {
                const saved = JSON.parse(sessionStorage.getItem("answers"));
                // Backward compat: CONTINENT2 (Eastern Europe) merged into CONTINENT1 (Europe)
                saved.forEach(a => { if (a.CONTINENT === 'CONTINENT2') a.CONTINENT = 'CONTINENT1'; });
                setSlidesAnswers(saved);
            }
        }
    }, [token])

    const updateValues = (index, key, value, msState) => {
        let newAnswers = slidesAnswers.map((v, k) => {
            if (k !== index) {
                return v;
            }
            v[key] = value;
            // Add chrono timestamp to each answer
            v[`${key}_timestamp`] = [{ 
                "hours": chrono.hours, 
                "minutes": chrono.minutes, 
                "seconds": chrono.seconds,
                "totalSeconds": (chrono.hours * 3600) + (chrono.minutes * 60) + chrono.seconds
            }];
            return v;
        })
        setSlidesAnswers(newAnswers);
        setButtonNext(null);
        console.log("updateValues with chrono", newAnswers);
        sessionStorage.setItem('answers', JSON.stringify(newAnswers))

        // Log the answer update
        logger.info(`Test answer updated: ${key} = ${value}`, 'test_answer', {
            questionKey: key,
            answerValue: value,
            stepIndex: index,
            chrono: chrono,
            totalAnswers: newAnswers.length
        });
    }

    return (
      <SlidesContext.Provider value={{ slidesAnswers, updateValues }}>
        <ChronoContext.Provider value={{ chrono, setChrono }}>
          <StepContext.Provider value={{ step, setStep }}>
            <ButtonNext.Provider value={{ buttonNext, setButtonNext }}>
              {/* Always show the slide info counter, but show as 1-based for user clarity */}
              <div className="Slide-info">
                <div className="Slide-info-step">
                  {
                    sessionStorage.getItem("demographics")
                      ? `${Math.max(1, parseInt(sessionStorage.getItem("step") || "0") + 1)}/${slidesWCS.length - 7}`
                      : `${Math.max(1, parseInt(sessionStorage.getItem("step") || "0") + 1)}/${slidesWCS.length - 2}`
                  }
                </div>
              </div>
              <div className="Content">
                <Preferences questions={slidesWCS} />
                <Slide questions={slidesWCS} token={token} />
              </div>
            </ButtonNext.Provider>
          </StepContext.Provider>
        </ChronoContext.Provider>
      </SlidesContext.Provider>
    )
}